import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Input,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IConsultationEncaissementTable, IAuthReduxProps, ITarget } from '../../types/interfaces';
import EncaissementScanModal from '../encaissement_list/EncaissementScanModal';
import EncDelayEdit from './EncDelayEdit';
import { PRIVILEGE } from '../../types/privileges'

import TableContainer from "../tables_manager/TableContainer"
import { addEncSorti } from '../../flux/actions/encsortiActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faMoneyCheck, faPlus, faEye, faPen, faHourglassHalf, faTimes, faCheckCircle, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { useAlert } from "react-alert";
import moment from "moment";
import { getFtpCheck } from '../../flux/actions/encaissementActions';
import Loading from '../Loading';
import { DateRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import { getEncModeRegl, getEncStatut } from '../../services/misc';
import { constants } from '../../types/constants';
import RepSwitchCell from '../tables_manager/RepSwitchCell';
import { instantPrint } from '../pdf/PDFLink';

const ConsultationEncaissementTable = ({ 
  linesData,
  associations,
  consultationOnly,
  isReplacement,
  venteID,
  embed,
  setAssociationPartInfo,
  switchToAssociation,
  addEncSorti,
  auth
 }: IConsultationEncaissementTable) => {
  const history = useHistory();
  const alert = useAlert();
  const skipResetRef = React.useRef(false);
  const [tableData, setTableData] = useState<any[]>([])
  const [modal, setModal] = useState(false);
  const [modalEncaissement, setModalEncaissement] = useState<any>('');
  const [encDelayModal, setEncDelayModal] = useState(false);
  const [encDelayModalData, setEncDelayModalData] = useState<any>(undefined);
  const [modalRep, setModalRep] = useState(false);
  const [commentRep, setCommentRep] = useState('');
  const [disableSubmitRep, setDisableSubmitRep] = useState(false);
  const [reEnableRep, setReEnableRep] = useState(false);

  const handleToggleRep = () => setModalRep(!modalRep)

  const modalClosedHandleRep = () => {
    setCommentRep('');
    if(reEnableRep){
      setDisableSubmitRep(false);
      setReEnableRep(false);
    }
  };

  const callbackRep = (success, print) => {
    if(success && !success.err){
      setReEnableRep(true);
      setModalRep(false);
      refreshRepSwitches()
      alert.success("Encaissements modifiés");
      if(print){
        instantPrint({
          documentType: "decharge",
          data: success,
          showPreviewWatermark: false,
        });
      }
      return
    }
    if(success?.err?.alreadyExists)
      alert.error("Demande déjà envoyée");
    else
      alert.error("Une erreur s'est produite");
    setDisableSubmitRep(false);
  }

  const replaceEncHandler = async action => {
    if(!action)
      return
    if(tableData.filter(e => !!e.replaced).length === 0){
      alert.error("Veuillez sélectionner les encaissement(s) remplacé(s)");
      return
    }
    const replacerIds = tableData?.filter(e => !!e.replacer).map(e => e.ID_ENCAISSEMENT || 0).filter((e, i, a) => i === 0 || a.indexOf(e) === i) || []
    const replacedIds = tableData?.filter(e => !!e.replaced).map(e => e.ID_ENCAISSEMENT || 0).filter((e, i, a) => i === 0 || a.indexOf(e) === i) || []
    if(replacerIds.find(e => replacedIds.includes(e))){
      alert.error("Vous avez sélectionné le même encaissement 2 fois");
      return
    }
    
    if(action === constants.VALIDATE_CHECK){
      setModalRep(true);
      return
    }
    else if(action === constants.VALIDATE_CONFIRM || action === constants.VALIDATE_CONFIRM_AND_PRINT){
      setDisableSubmitRep(true);
      addEncSorti(replacerIds, replacedIds, venteID || -1, commentRep, callbackRep, true/*action === constants.VALIDATE_CONFIRM_AND_PRINT*/);
    }
  };

  useEffect(() => {
    refreshRepSwitches()
  }, [linesData])

  const refreshRepSwitches = () => setTableData(linesData.map(e => ({replacer: false, replaced: false, ...e})))

  const columns = [
    ...(isReplacement ? [{
      Header: "À Récupérer",
      accessor: "replaced",
      Cell: RepSwitchCell,
      className: "text-center",
      disableFilters: true,
    },
    {
      Header: "À Attacher",
      accessor: "replacer",
      Cell: RepSwitchCell,
      className: "text-center",
      disableFilters: true,
    }] : []),
    {
      Header: "ID Système",
      id: "ID Système",
      accessor: row => row.encaissement?.id || "",
      customExportDisplay: `$.encaissement ? $.encaissement.id : ""`,
      Cell: ({ value }) => value || "-",
      // hidden: true
    },
    {
      Header: "Tiré par",
      id: "Tiré par",
      accessor: row => row.encaissement?.TIRE_PAR || "",
      customExportDisplay: `$.encaissement ? $.encaissement.TIRE_PAR : ""`,
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Au profit de",
      accessor: "PROFIT_DE",
      Cell: ({ value }) => value && value != "00000000000000000" ? value : "-"
    },
    {
      Header: "Mode de règlement",
      id: "Mode de règlement",
      accessor: row => getEncModeRegl(row.encaissement?.MODE_REGL),
      customExportDisplay: `getEncModeReglHandle($.encaissement ? $.encaissement.MODE_REGL : "")`,
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Type échéance",
      accessor: "TYPE_ECHEANCE",
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Réf. Règlement",
      id: "Réf. Règlement",
      accessor: row => row.encaissement?.REF_REGLEMENT || "",
      customExportDisplay: `$.encaissement ? $.encaissement.REF_REGLEMENT : ""`,
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Banque",
      id: "Banque",
      accessor: row => row.encaissement?.BANQUE || "",
      customExportDisplay: `$.encaissement ? $.encaissement.BANQUE : ""`,
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Date Encaissement",
      id: "Date Encaissement",
      accessor: row => row.encaissement?.DATE_REGLEMENT || "",
      customExportDisplay: `$.encaissement && $.encaissement.DATE_REGLEMENT ? new Date($.encaissement.DATE_REGLEMENT) : "-"`,
      Cell: ({ value, row: {original} }) => <>
        <div>{value ? moment(value).format('DD/MM/YYYY') : "-"}{!!(original.encaissement?.MODE_REGL === constants.MODE_REGL_CHEQUE && original.encaissement?.STATUT && [constants.STATUT_ENC_DEFAULT, constants.STATUT_ENC_PTF].includes(original.encaissement.STATUT) && (auth?.user?.id && auth.user.speciality && (auth?.user?.id === original.encaissement?.SAISIE_PAR_ID || auth?.user?.id === original.encaissement?.ID_COM || [constants.ROLE_ADMIN, constants.ROLE_DG, constants.ROLE_DC, constants.ROLE_DAF, constants.ROLE_RESPONSABLE].includes(auth.user.speciality)))) && <FontAwesomeIcon icon={faHourglassHalf} style={{marginLeft: "3px", cursor: original.encaissement?.dateVerseDelayValid !== -1 && original.encaissement?.dateVerseDelayValid !== 1 ? "pointer" : "default", fontSize: "small", color: original.encaissement?.dateVerseDelayValid === 0 ? "orange" : "darkgreen", opacity: original.encaissement?.dateVerseDelayValid !== -1 && original.encaissement?.dateVerseDelayValid !== 1 ? 1 : .3}} title={original.encaissement?.dateVerseDelayValid === -1 ? "Demande déjà envoyée" : original.encaissement?.dateVerseDelayValid === 1 ? "Demande déjà acceptée" : original.encaissement?.dateVerseDelayValid === 0 ? "Demande refusée, cliquez pour envoyer une autre demande" : "Envoyer une demande de prolongation de la date du encaissement du chèque"} onClick={() => {if(original.encaissement?.dateVerseDelayValid !== -1 && original.encaissement?.dateVerseDelayValid !== 1){setEncDelayModal(true); setEncDelayModalData(original.encaissement)}}} />}</div>
        {!!(original.encaissement?.dateVerseDelayValid === -1 && original.encaissement?.dateVerseDelayDate) && <div style={{fontSize: "x-small", fontStyle: "italic"}}>Demandée: {moment(original.encaissement.dateVerseDelayDate).format('DD/MM/YYYY')}</div>}
      </>
    },
    {
      Header: "Date de CHQ/VAL",
      id: "Date de CHQ/VAL",
      accessor: row => row.encaissement?.DATE_PORTEFEUILLE || "",
      customExportDisplay: `$.encaissement && $.encaissement.DATE_PORTEFEUILLE ? new Date($.encaissement.DATE_PORTEFEUILLE) : "-"`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
      // hidden: true
    },
    {
      Header: "Montant encaissé",
      accessor: "PART",
      filter: "equals",
      Cell: ({ row: {original} }) => original.PART === original.encaissement?.MONTANT ? ((original.PART !== null && original.PART !== undefined && original.PART != "") ? (original.PART.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-") : (<div><div style={{display: "inline-block", whiteSpace: "nowrap"}}>{(original.PART !== null && original.PART !== undefined && original.PART != "") ? (original.PART.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}&nbsp;</div><div style={{display: "inline-block", whiteSpace: "nowrap"}}>{(original.encaissement?.MONTANT !== null && original.encaissement?.MONTANT !== undefined && original.encaissement?.MONTANT != "") ? ("(de " + original.encaissement.MONTANT.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh)") : "-"}</div></div>)
    },
    {
      Header: "Banque versement",
      id: "Banque versement",
      accessor: row => row.encaissement?.BANQUE_VERSEMENT || "",
      customExportDisplay: `$.encaissement ? $.encaissement.BANQUE_VERSEMENT : ""`,
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Type Client",
      accessor: e => !e.encaissement ? "" : e.encaissement.typeClient === 3 ? "Salarié" : e.encaissement.typeClient === 2 ? "Promoteur" : "Client",
      Filter: SelectColumnFilter,
      filter: 'equals',
      hidden: true
    },
    {
      Header: "Validé",
      accessor: e => e.encaissement?.notValid == 1 ? "Non" : "Oui",
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => <b style={value === "Non" ? {color: "darkred"} : {}}>{value}</b>,
    },
    {
      Header: "Statut",
      accessor: row => getEncStatut(row.encaissement?.STATUT),
      customExportDisplay: `$.encaissement ? getEncStatutHandle($.encaissement.STATUT) : ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "Saisie le",
      id: "Saisie le",
      accessor: e => e.encaissement?.createdAt || "",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
      customExportDisplay: `$.encaissement && $.encaissement.createdAt ? new Date($.encaissement.createdAt) : "-"`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
      hidden: true
    },
    {
      Header: "Saisie par",
      id: "Saisie par",
      accessor: (row, index) => row.encaissement?.user?.LOGIN || row.encaissement?.SAISIE_PAR || "",
      customExportDisplay: `$.encaissement && $.encaissement.user ? $.encaissement.user.LOGIN : ($.encaissement.SAISIE_PAR || "")`,
      // filter: (rows, id, e) => rows.filter(t => t.original[id]?.LOGIN?.toLowerCase().includes(e.toLowerCase())),
      // sortType: (a, b, id, desc) => a.original[id]?.LOGIN > b.original[id]?.LOGIN ? 1 : -1,
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Commissionné à",
      accessor: "commi",
      filter: (rows, id, e) => rows.filter(t => (t.original.encaissement?.commission_histories?.filter((e, index, self) => self.findIndex(t => t.comId === e.comId) === index).map(e => e.comUserCommissionHistory?.LOGIN || "-") || []).includes(e)),
      customExportDisplay: `($.encaissement && $.encaissement.commission_histories && $.encaissement.commission_histories.length) ? $.encaissement.commission_histories.filter((e, index, self) => self.findIndex(t => t.comId === e.comId) === index).map(t => t.comUserCommissionHistory && t.comUserCommissionHistory.LOGIN ? t.comUserCommissionHistory.LOGIN : "-").join(" / ") : "-"`,
      // Cell: ({ row: {original} }) => original.contrat_encaissements?.length ? original.contrat_encaissements.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map(e => e.contrat?.NUM_DOSS || "-").join(" et ") : "-",
      Cell: ({ row: {original} }) => original.encaissement?.commission_histories?.length ? original.encaissement.commission_histories.filter((e, index, self) => self.findIndex(t => t.comId === e.comId) === index).map(e => e.comUserCommissionHistory?.LOGIN || "-").join(", ") : "-",
      hidden: true
    },
    ...(associations?.length ? [{
      Header: "Association",
      accessor: "ID_ASS",
      disableFilters: true,
      Cell: ({ value }) => {
        const assTemp = associations.find(e => e.id === Number(value || 0));
        if(assTemp)
          return <div style={{textAlign: "center"}}>
            <div>{assTemp.ETAGE === "0" ? "RDC" : (assTemp.ETAGE ? `Étage ${assTemp.ETAGE}` : "-")}</div>
            <div style={{display: "inline-block", marginRight: "5px"}}>{assTemp.POURCENTAGE || "-"}%</div>
            <FontAwesomeIcon icon={faEye} style={{cursor: "pointer"}} onClick={() => {
              if(switchToAssociation)
                switchToAssociation();
              if(setAssociationPartInfo)
                setTimeout(() => setAssociationPartInfo(assTemp), 500);
            }} />
          </div>
        return "-"
      }
    }] : []),
    {
      Header: "Aperçus",
      className: "text-center",
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row: {original} }) => (
          <Container className="actionsContainer">
              {original.encaissement && (original.encaissement.recto_name ||original.encaissement.verso_name || original.encaissement.URL || original.encaissement.URL_VERSO) ? <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
                onClick={() => (setModalEncaissement(original.encaissement), setModal(true))}
                title="Aperçu des Scans">
                <FontAwesomeIcon icon={faMoneyCheck} />
              </button> : null}
              {/* <button className="btn btn-danger btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                onClick={() => handleDelete(row.original.lineIndex)}
                title="Supprimer">
                <FontAwesomeIcon icon={faTrash} />
              </button> */}
          </Container>
      ),
    }
  ];

  const updateMyData = (rowIndex, columnId, value) => {
    // setSkipPageReset(true);
    skipResetRef.current = true;
    setTableData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          }
        }
        return row
      })
    )
  }

  return (
    <>
      <Container style={embed ? {maxWidth: "100%"} : {}}>
        <TableContainer columns={columns} data={tableData} dataName="encaissements" enableCheckBox={false} hideExport={!!embed} /*disableFilter={!linesData || linesData.length <= 5}*/ hideFiltersByDefault isEditable={!!isReplacement} updateMyData={updateMyData} skipPageReset={skipResetRef.current} />
        {!!(consultationOnly && venteID && auth?.user?.privileges?.includes(PRIVILEGE.ADD_ENCAISSEMENT)) && <Row className="justify-content-end" style={{gap: "10px"}}>
          <Button
            className="btn btn-info linesConfirmationBtn linesDeleteBtn"
            onClick={() => history.push(`/nouvel_encaissement/${venteID}`)}
            ><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Ajouter un autre encaissement</Button>
          <Button
            className="btn btn-warning linesConfirmationBtn linesDeleteBtn"
            onClick={() => history.push(`/remplacement_encaissement/${venteID}`)}
            ><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Remplacer un encaissement</Button>
        </Row>}
      </Container>
      {!!(isReplacement && venteID) && <Container className="confirmDiv" fixed="down">
        <Row className="justify-content-center">
          <Col xs="12" md="6">
            <FormGroup>
              <Button
                // color="info"
                className={`${/*blockInput ? "btn-danger" : */"btnA"} confirmBtn`}
                onClick={() => replaceEncHandler(constants.VALIDATE_CHECK)}
                // disabled={blockInput}
                ><FontAwesomeIcon icon={faCheckCircle} />&nbsp;&nbsp;{`Valider ${tableData.filter(e => e.replaced || e.replacer).length ? `— ${tableData.filter(e => e.replaced).length} remplacés par ${tableData.filter(e => e.replacer).length} encaissements` : ""}`}</Button>
            </FormGroup>
          </Col>
        </Row>
      </Container>}
      <EncaissementScanModal modal={modal} setModal={setModal} modalEncaissement={modalEncaissement} setModalEncaissement={setModalEncaissement} />
      <EncDelayEdit modal={encDelayModal} setModal={setEncDelayModal} modalData={encDelayModalData} />
      <Modal isOpen={modalRep} toggle={handleToggleRep} onClosed={modalClosedHandleRep}>
        <ModalHeader toggle={handleToggleRep}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Demande de remplacement de chèque</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer">
            <Row className="mb-2">
              <Col xs="12">
                Êtes-vous sûr de vouloir enlever <b>{tableData.filter(e => !!e.replaced).length === 1 ? "l'" : `les ${tableData.filter(e => !!e.replaced).length} `}encaissement{tableData.filter(e => !!e.replaced).length === 1 ? "" : "s"}</b> ?
              </Col>
            </Row>
            {tableData.filter(e => !!e.replaced).length ? <Row style={{justifyContent: "center", fontWeight: 700}}>
              <div style={{color: "orangered"}}>À Récupérer</div>&nbsp;({tableData.filter(e => !!e.replaced).reduce((e, t) => e + Number(t.encaissement?.MONTANT || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)
            </Row> : null}
            {tableData.filter(e => !!e.replaced).map((e, key) => (
              <Row className="linesConfirmationLines" key={key}>
                <Col xs="12">{getEncModeRegl(e.encaissement?.MODE_REGL)} N°: <b>{e.encaissement?.REF_REGLEMENT || "-"}</b> Montant: <b>{(e.encaissement?.MONTANT || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</b></Col>
              </Row>
            ))}
            {tableData.filter(e => !!e.replacer).length ? <Row style={{justifyContent: "center", fontWeight: 700}}>
              <div style={{color: "green"}}>À Attacher</div>&nbsp;({tableData.filter(e => !!e.replacer).reduce((e, t) => e + Number(t.encaissement?.MONTANT || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)
            </Row> : null}
            {tableData.filter(e => !!e.replacer).map((e, key) => (
              <Row className="linesConfirmationLines" key={key}>
                <Col xs="12">{getEncModeRegl(e.encaissement?.MODE_REGL)} N°: <b>{e.encaissement?.REF_REGLEMENT || "-"}</b> Montant: <b>{(e.encaissement?.MONTANT || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</b></Col>
              </Row>
            ))}
            <Row>
              <Col xs="12">
                <Input id="comment" type="textarea" placeholder="Commentaire..." value={commentRep} onChange={e => setCommentRep(e.target.value)} />
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Button
                className="btn btn-success linesConfirmationBtn"
                onClick={() => replaceEncHandler(constants.VALIDATE_CONFIRM_AND_PRINT)}
                disabled={disableSubmitRep}
                ><FontAwesomeIcon icon={disableSubmitRep ? faSpinner : faCheckCircle} className={disableSubmitRep ? "spinner" : ""} />&nbsp;&nbsp;Envoyer et Imprimer la demande</Button>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    </>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { addEncSorti })(ConsultationEncaissementTable);
